import { useQuery } from '@tanstack/react-query';
import { REPORTING_STORE_ORDER_FIELDS } from '@tempo-io/reporting-store-dto';
import { ItemsApi } from '@/common/api/items';
import type { ItemFieldDto } from '@/common/api/types/items';
import { useFlag } from '@/common/hooks/feature-flags/useFlag';
import { commonQueryKeys } from '@/common/queryKeys/common';

const EMPTY_SET: ReadonlySet<string> = new Set();

// Sortable fields differ by serving service — offering the wrong one is a 400.
export const useSortableItemFields = (): {
  sortableItemFields: ReadonlySet<string>;
  isLoaded: boolean;
} => {
  const readsReportingStore = useFlag('reportingServiceFilter');
  const { data, isSuccess } = useQuery({
    queryKey: commonQueryKeys.itemFields.all(),
    queryFn: () => ItemsApi.getItemFields(),
    staleTime: Number.POSITIVE_INFINITY,
    // Nothing reads item-store's answer under the flag.
    enabled: !readsReportingStore,
    select: (fields: ItemFieldDto[]) =>
      new Set(fields.filter((f) => f.sortable).map((f) => f.name)) as ReadonlySet<string>,
  });
  return {
    sortableItemFields: readsReportingStore ? REPORTING_STORE_ORDER_FIELDS : (data ?? EMPTY_SET),
    // Under the flag the fields are already known, so a failed `/items/fields` shouldn't block the table.
    isLoaded: readsReportingStore || isSuccess,
  };
};
